import { ItemCategory, ItemCommissionType } from '@prisma/client';
import { QueryKey } from '@tanstack/react-query';
import { LoadedUser } from '../../interfaces';
import { convertSnakeToTitleCase } from '../../utils/global/helper';
import { ItemWithCommissions, SearchItemsPage } from '../../types/items';
import client from '../../utils/react-query/client';

export function getCommissionEmployees(
  employees: LoadedUser['business']['employees'] | undefined | null,
) {
  if (!employees?.length) return [];

  return employees.filter(employee => employee.payrollType === 'COMMISSION');
}

export function getTextForCategory(category: ItemCategory) {
  return convertSnakeToTitleCase(category);
}

export function getTextForCommissionType(type: ItemCommissionType) {
  return `Commissions paid on ${convertSnakeToTitleCase(type).toLowerCase()}`;
}

export function updateItemInList({
  queryKey,
  itemId,
  data,
}: {
  queryKey: QueryKey;
  itemId: string;
  data: Partial<ItemWithCommissions>;
}) {
  client.setQueryData<ItemWithCommissions[]>(
    queryKey,
    items =>
      items?.map(item => {
        if (item.id === itemId) {
          return {
            ...item,
            ...data,
          };
        }
        return item;
      }),
  );
}

export function updateItemInPaginatedList({
  queryKey,
  itemId,
  data,
}: {
  queryKey: QueryKey;
  itemId: string;
  data: Partial<ItemWithCommissions>;
}) {
  client.setQueryData<{
    pages: SearchItemsPage[];
    pageParams: (string | undefined)[];
  }>(queryKey, oldData => {
    if (!oldData) return oldData;

    return {
      ...oldData,
      pages: oldData.pages.map(page => ({
        ...page,
        result: page.result.map(item =>
          item.id === itemId ? { ...item, ...data } : item,
        ),
      })),
    };
  });
}
